import './firstamericans/style';
import FormStructure from './firstamericans/form_structure';

export default FormStructure;